import { defineAppConfig } from 'ice';

// App config, see https://ice3.alibaba-inc.com/v3/docs/guide/basic/app
export default defineAppConfig(() => ({
  // Set your configs here.
}));